import { CdkDragDrop, CDK_DRAG_CONFIG } from '@angular/cdk/drag-drop';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { merge, Observable, of, Subject } from 'rxjs';
import { filter, map, startWith, switchMap, takeUntil } from 'rxjs/operators';
import { SettlementService } from 'src/app/services/settlement.service';
import { CreateGroupComponent } from '../create-group/create-group.component';
import { ConfirmDialogComponent } from '../dialogs/confirm-dialog/confirm-dialog.component';
import { SnackbarComponent } from '../snackbar/snackbar.component';
const DragConfig = {
  dragStartThreshold: 0,
  pointerDirectionChangeThreshold: 5,
  zIndex: 999999999
};
@Component({
  selector: 'app-settlement-group',
  templateUrl: './settlement-group.component.html',
  styleUrls: ['./settlement-group.component.scss'],
  providers: [{ provide: CDK_DRAG_CONFIG, useValue: DragConfig }]
})
export class SettlementGroupComponent implements OnInit,OnDestroy {
  private destroy$ = new Subject<void>();
  settlements: any[] = [];
  master_checked: boolean = false;
  selectedSettlements: any[] = [];
  addToSettlements$: Observable<any> = new Observable();
  addToGroup$: Observable<any> = new Observable();
  searchInput: FormControl = new FormControl();
  searchGroup: FormControl = new FormControl();
  expanded: {} = {};
  settlementsGroups: any = [];
  expandedBoxes: {} = {};
  actions: any[];
  isHovered: boolean = false;
  settlementsDragging: boolean = false;
  itemsName: any[] =[];
  loading:boolean=false;
  loadingGroups:boolean=false;
  startRow:number= 0;
  itemStartRow:number=0;
  amountPerPage:number= 15;
  constructor(
    private settlementService: SettlementService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog
    ) { }

  ngOnInit(): void {
    this.getSettlementsItems(true);
    this.getGroups(true);
    this.actions = [
      { text: "Apply" },
    ];
    this.searchInput.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value) => {
        this.getSettlementsItems(true,value)
      });
      this.searchGroup.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value) => {
        this.getGroups(true,value)
      });
  }

  getSettlementsItems(reset=false,globalSearch=""): void {
    this.loading=true;
    if (!reset) {
      this.itemStartRow += this.amountPerPage
    } else {
      this.itemStartRow = 0;
    }
    const payload={
      startRow: this.itemStartRow,
      endRow:  this.itemStartRow + this.amountPerPage,
      globalSearch:globalSearch
    }

    this.settlementService
      .GetSettlementItemForGroup(payload)
      .pipe(takeUntil(this.destroy$)).subscribe({
      next: (data:any) => {
        if (reset) {
          this.settlements = [];
        }
        this.settlements.push(...data);
        this.loading=false;
        this.master_checked=false;
        this.selectedSettlements = [];
      },
     error: (err) => {
      this.loading=false;
      this.snackBar.openFromComponent(SnackbarComponent, {
      duration: 3000,
      horizontalPosition: "center",
      data: {
        title: err?.error?.error[0],
        action: "Dismiss",
        type: "error",
      },
    });
     }
   });
  }

  getGroups(reset=false,globalSearch=""): void {
    this.loadingGroups=true;
    if (!reset) {
      this.startRow += this.amountPerPage
    } else {
      this.startRow = 0;
    }
    const payload={
      globalSearch:globalSearch,
      startRow: this.startRow,
      endRow:  this.startRow + this.amountPerPage,
    }
      this.settlementService
      .GetGroups(payload)
      .pipe(takeUntil(this.destroy$)).subscribe({
        next: (data:any) => {
          if (reset) {
            this.settlementsGroups = [];
          }
          this.settlementsGroups.push(...data);
          this.loadingGroups=false;
        },
       error: (err) => {
        this.loadingGroups=false;
        this.snackBar.openFromComponent(SnackbarComponent, {
          duration: 3000,
          horizontalPosition: "center",
          data: {
            title: err.error.error[0],
            action: "Dismiss",
            type: "error",
          },
        });
       }
     });
  }

  createGroup(e: MouseEvent, settlement?) {
    e.stopPropagation();
    this.dialog.open(CreateGroupComponent, {
      width: "263px",
      backdropClass: "column-dialog",
      position: this.getDialogPosition(e),
      data: {
        settlement: settlement
      }
    })
    .afterClosed()
      .pipe(filter((e) => e === "Confirm" ||  e === "Save"))
      .subscribe((e) => {
        this.getGroups(true);
      });
  }

  getDialogPosition(e: MouseEvent) {
    const target = e.target as any;
    const targetPosision = target.getBoundingClientRect();
    return {
      left: targetPosision.right - 280 + "px",
      top: targetPosision.top + 30 + "px",
    };
  }

  setSelectAll(event) {
    this.master_checked = event.checked;
    for (let value of Object.values(this.settlements)) {
      value.checked = this.master_checked;
    }
    this.isSelectAll();
  }

  isSelectAll() {
    if (this.master_checked) {
      this.selectedSettlements = [];
      this.settlements.forEach(val => {
        this.selectedSettlements.push(Object.assign({}, val))
      });
    } else if (this.selectedSettlements.length == this.settlements.length && !this.master_checked) {
      this.selectedSettlements = [];
    }
  }

  selectSettlement(event, item) {
    if (event.checked) {
      this.selectedSettlements.push(item);
      let index=this.settlements.findIndex(res=> !res.checked);
      if(index !== -1){
        this.master_checked =false;
      } else{
        this.master_checked =true;
      }
    } else {
      const unselectSettlementIndex = this.selectedSettlements.findIndex((res: any) => {
        return res.amountType === item.amountType;
      });
      this.selectedSettlements.splice(unselectSettlementIndex, 1);
      this.master_checked = false;
    }
  }

  deleteGroup(e: MouseEvent, settlementGroup) {
    e.stopPropagation();
    this.dialog
      .open(ConfirmDialogComponent, {
        width: "500px",
        data: {
          title: "Delete Group",
          message: `Are you sure you want to delete this Group?`,
          actions: [
            { text: "Cancel", buttonStyle: "underline" },
            { text: "Confirm", buttonColor: "accent", buttonStyle: "wire" },
          ],
        },
      })
      .afterClosed()
      .pipe(filter((e) => e === "Confirm"))
      .subscribe((e) => {
        let payload: any = {
          groupIds: [settlementGroup.settlementGroupId]
        }
        this.settlementService.DeleteGroup(payload).pipe(takeUntil(this.destroy$)).subscribe({
          next: (res) => {
            this.getSettlementsItems(true,this.searchInput.value);
            this.getGroups(true,this.searchGroup.value);
            this.snackBar.openFromComponent(SnackbarComponent, {
              duration: 3000,
              horizontalPosition: 'center',
              data: {
                title: ` Settlement group deleted successfully.`,
                action: 'Dismiss',
                type: 'info',
              },
            });
          },
         error: (err) => {
          this.snackBar.openFromComponent(SnackbarComponent, {
            duration: 3000,
            horizontalPosition: "center",
            data: {
              title: err.error.error[0],
              action: "Dismiss",
              type: "error",
            },
          });
         }
       });
    });
  }

  deleteGroupItem(e: MouseEvent, groupItem) {
    e.stopPropagation();
    this.dialog
      .open(ConfirmDialogComponent, {
        width: "500px",
        data: {
          title: "Delete Item",
          message: `Are you sure you want to delete ${groupItem.name} from this group ?`,
          actions: [
            { text: "Cancel", buttonStyle: "underline" },
            { text: "Confirm", buttonColor: "accent", buttonStyle: "wire" },
          ],
        },
      })
      .afterClosed()
      .pipe(filter((e) => e === "Confirm"))
      .subscribe((e) => {
        let payload: any = {
          settlementGroupItemIds:[groupItem.settlementGroupItemId],
        }
        this.settlementService.DeleteGroupItems(payload).pipe(takeUntil(this.destroy$)).subscribe({
          next: (res) => {
            this.getSettlementsItems(true,this.searchInput.value);
            this.getGroups(true,this.searchGroup.value);
            this.snackBar.openFromComponent(SnackbarComponent, {
              duration: 3000,
              horizontalPosition: 'center',
              data: {
                title: `${groupItem.name} item deleted successfully.`,
                action: 'Dismiss',
                type: 'info',
              },
            });
          },
         error: (err) => {
          this.snackBar.openFromComponent(SnackbarComponent, {
            duration: 3000,
            horizontalPosition: "center",
            data: {
              title: err.error.error[0],
              action: "Dismiss",
              type: "error",
            },
          });
         }
       });
    });
  }

  drop(e: CdkDragDrop<any>, settlementGroup) {
    if (e.isPointerOverContainer && this.isHovered) { 
      if(this.selectedSettlements){
        this.selectedSettlements.filter((res)=>{
          this.itemsName.push(res.amountType)
        })
      }    
      const settlement: any = e.item.data;
      const itemNamePayload =   this.selectedSettlements.length ? this.itemsName : [settlement.amountType];      
      const payload: any ={
        settlementGroupId: settlementGroup.settlementGroupId,
        itemNames: itemNamePayload
      }
      this.settlementService
        .SaveGroupItems(payload)
        .pipe(takeUntil(this.destroy$)).subscribe({
        next: (data:any) => {
          this.getSettlementsItems(true,this.searchInput.value);
          this.getGroups(true,this.searchGroup.value);
          this.itemsName = [];
          this.selectedSettlements = [];
          this.master_checked= false;
            this.snackBar.openFromComponent(SnackbarComponent, {
              duration: 3000,
              horizontalPosition: 'center',
              data: {
                title: `Item added successfully.`,
                action: 'Dismiss',
                type: 'success',
              },
          });
        },
       error: (err) => {
        this.snackBar.openFromComponent(SnackbarComponent, {
          duration: 3000,
          horizontalPosition: "center",
          data: {
            title: err.error.error[0],
            action: "Dismiss",
            type: "error",
          },
      });   
       }
     });
    }
  }

  skuDrag(e) {
    this.settlementsDragging=  true;
  }

  entered(event) {
    this.isHovered = true;
  }

  exited(event) {
    this.isHovered = false;
  }
  
  clearSearch(isGroup) {
    !isGroup ? this.searchInput.setValue("") : this.searchGroup.setValue("");
  }

  cdkDragEnded(event){
    this.settlementsDragging=  false;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
